import * as React from 'react';

import { cn } from '@/lib/utils';

interface AuthContainerProps {
  children: React.ReactNode;
  className?: string;
}

export function AuthContainer({ children, className }: AuthContainerProps) {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-16">
      <div className={cn('w-full max-w-md space-y-8', className)}>
        {children}
      </div>
    </div>
  );
}
